import React from 'react';
import styled from 'styled-components';
import { theme } from '../config/theme';
import { isVideo } from './Media/Media';

// Background container for hero sections
const BackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

// Image background
const BackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background: url(${props => props.src}) center/cover;
  background-attachment: fixed;
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    background-attachment: scroll;
  }
`;

// Video background
const BackgroundVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

// Overlay for darkening/lightening the background
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => props.overlay || theme.shadows.overlay.light};
  z-index: 1;
`;

// Main hero background component
const HeroBackground = ({ 
  src, 
  overlay = theme.shadows.overlay.light,
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
  ...props 
}) => {
  return (
    <BackgroundContainer {...props}>
      {isVideo(src) ? (
        <BackgroundVideo
          src={src}
          autoPlay={autoPlay}
          loop={loop}
          muted={muted}
          playsInline={playsInline}
          aria-label="Hero background video"
        />
      ) : (
        <BackgroundImage 
          src={src} 
          role="img" 
          aria-label="Pilates studio interior with natural light and professional Reformer equipment at The Sol Room"
        />
      )}
      <Overlay overlay={overlay} />
    </BackgroundContainer>
  );
};

export default HeroBackground;